import "core-js/modules/es.array.push.js";
const InternalTestNames = {
  HIDE_QA_SECTION: "PDP_QA",
  COOP_BRAND_ASSET: "PDP_COOP_BRAND_Test",
  STAFF_BADGE_NAME: "Staff Pick",
  HIDE_STAFF_PICK: "Search_PDP_StaffPickBadge",
  KLARNA_V2: "PDP_KlarnaMsg",
  REWARDS_PLACEMENTS: "PDP_RewardsPlacements",
  PARITY_REVIEWS: "PDP_ParityReviews",
  GLADLY_TEST: "PDP_SCS_Test"
};
const testGetters = {
  /**
   * Add logic here for future Adobe A/B tests to keep the logic clean
   * and centralized. Tests are currently mutually exclusive.
   *
   * @returns A list of all eligible tests for the current PDP
   */
  getEligibleTests(state, getters) {
    var _a, _b, _c;
    let test;
    const eligibleTests = [];
    const {
      activeAdobeExperiments,
      appPropsMap
    } = getters;
    const activeExps = activeAdobeExperiments.map((activeTest) => {
      const arr = activeTest.split(":");
      return {
        aName: arr[0],
        // Adobe test name
        exp: arr[1],
        // Adobe test experience (A, B, variant, etc.)
        name: ""
        // Analytics/internal name of test
      };
    });
    const getTest = (aStr = "") => {
      const aName = aStr.split(":")[0];
      return activeExps.find((t) => aName === t.aName);
    };
    test = getTest(getters.appPropsMap.abTestNames.klarnaV2);
    if (test) {
      const {
        minPrice
      } = getters.computedPrice;
      const isKlarnaEligible = (minPrice == null ? void 0 : minPrice.value) >= 30 && (minPrice == null ? void 0 : minPrice.value) <= 3e3;
      if (isKlarnaEligible) {
        test.name = "PDP_KlarnaMsg";
        eligibleTests.push(test);
      }
    }
    const isStaffPicksTest = state.akamaiTestSegment !== void 0 && (state.akamaiTestSegment === getters.appPropsMap.abTestNames.staffPicksBadgeControl || state.akamaiTestSegment === getters.appPropsMap.abTestNames.staffPicksBadgeVariant);
    const hasBadge = ((_b = (_a = state.product.badges) == null ? void 0 : _a[0]) == null ? void 0 : _b.badgeText) === InternalTestNames.STAFF_BADGE_NAME;
    if (isStaffPicksTest && hasBadge) {
      eligibleTests.push({
        aName: InternalTestNames.HIDE_STAFF_PICK,
        name: InternalTestNames.HIDE_STAFF_PICK,
        exp: state.akamaiTestSegment
      });
    }
    test = getTest(getters.appPropsMap.abTestNames.showBillboardsMixedPriceTreatment);
    if (test) {
      test.name = "PDP_showBillboardsMixedPrice";
      eligibleTests.push(test);
    }
    test = getTest(getters.appPropsMap.abTestNames.scsVariant1);
    if (test) {
      test.name = InternalTestNames.GLADLY_TEST;
      if (getters.isGladlyTestCategory) {
        eligibleTests.push(test);
      }
    }
    test = getTest(getters.appPropsMap.abTestNames.hideQASectionVariant) || getTest(getters.appPropsMap.abTestNames.hideQASectionControl);
    if (test) {
      test.name = InternalTestNames.HIDE_QA_SECTION;
      eligibleTests.push(test);
    }
    test = getTest(getters.appPropsMap.abTestNames.coopBrandAssetControl) || getTest(getters.appPropsMap.abTestNames.coopBrandAssetVariant1) || getTest(getters.appPropsMap.abTestNames.coopBrandAssetVariant2) || getTest(getters.appPropsMap.abTestNames.coopBrandAssetVariant3);
    if (test) {
      test.name = InternalTestNames.COOP_BRAND_ASSET;
      eligibleTests.push(test);
    }
    test = getTest(appPropsMap.abTestNames.requiredItems);
    if (test) {
      if (!((_c = appPropsMap == null ? void 0 : appPropsMap.launchToggles) == null ? void 0 : _c.requiredItems)) {
        test.name = "PDP_RequiredItems";
        eligibleTests.push(test);
        return eligibleTests;
      }
    }
    test = getTest(appPropsMap.abTestNames.shopTheLook);
    if (test && getters.sellableCuratedOutfitProducts.length >= 2 && !getters.isPup) {
      test.name = "PDP_ShopTheLook";
      eligibleTests.push(test);
      return eligibleTests;
    }
    const isSaleFlairTest = state.akamaiTestSegment !== void 0 && (state.akamaiTestSegment === getters.appPropsMap.abTestNames.saleFlairVariant || state.akamaiTestSegment === getters.appPropsMap.abTestNames.saleFlairControl);
    if (isSaleFlairTest && state.product.flairBadge) {
      eligibleTests.push({
        aName: "PDP_SaleFlair",
        name: "PDP_SaleFlair",
        exp: state.akamaiTestSegment
      });
    }
    const isRewardsPlacementsTest = state.akamaiTestSegment !== void 0 && (state.akamaiTestSegment === getters.appPropsMap.abTestNames.rewardsPlacementsControl || state.akamaiTestSegment === getters.appPropsMap.abTestNames.rewardsPlacementsVariant);
    if (isRewardsPlacementsTest) {
      eligibleTests.push({
        aName: InternalTestNames.REWARDS_PLACEMENTS,
        name: InternalTestNames.REWARDS_PLACEMENTS,
        exp: state.akamaiTestSegment
      });
    }
    test = getTest(getters.appPropsMap.abTestNames.parityReviewsControl) || getTest(getters.appPropsMap.abTestNames.parityReviewsVariant);
    if (test) {
      test.name = InternalTestNames.PARITY_REVIEWS;
      eligibleTests.push(test);
    }
    return eligibleTests;
  },
  /**
   * A helper function to get a comma delimited list of active test names,
   * for ease of comparison/analytics.
   *
   * @returns comma delimited list of current test names
   */
  getEligibleTestsList(_state, getters) {
    return getters.getEligibleTests.filter((val) => val.name).filter((val) => !val.noAnalytics).map((val) => val.name).join(",");
  },
  /**
   *
   * getters.relatedProductsTestVariant
   *
   * @params from getters.selectedRelatedProducts
   * @params from getters.appPropsMap.abTestNames
   * @params from getters.getEligibleTests
   * @param {Array} selectedRelatedProducts
   * @param {string} recommendedItems
   * @param {string} requiredItems
   * @param {Array} getters.getEligibleTests
   *
   * @returns {string}: e.g. 'inline', 'addToCart'
   */
  // PDX-4661 A/B Test Cleanup For Required
  relatedProductsTestVariant(state, getters) {
    var _a, _b, _c;
    if (getters.selectedRelatedProducts.length) {
      const target = [(_b = (_a = getters.appPropsMap) == null ? void 0 : _a.abTestNames) == null ? void 0 : _b.requiredItems];
      const variant = ((_c = getters.getEligibleTests.find((elem) => target.includes(elem.aName))) == null ? void 0 : _c.exp) || "";
      return variant;
    }
    return "";
  },
  showShopTheLook(state, getters) {
    var _a;
    const shopTheLookTest = (_a = getters == null ? void 0 : getters.getEligibleTests) == null ? void 0 : _a.find((test) => test.name === "PDP_ShopTheLook");
    return ((shopTheLookTest == null ? void 0 : shopTheLookTest.exp) === "Variant" || getters.appPropsMap.launchToggles.showShopTheLook) && !getters.isPup;
  },
  showScsVariant1(state, getters) {
    const {
      appPropsMap: {
        abTestNames,
        launchToggles
      }
    } = getters;
    return getters.isGladlyTestCategory && launchToggles.enableExpertiseChat || getters.getEligibleTests.some((test) => `${test.aName}:${test.exp}` === abTestNames.scsVariant1);
  },
  showScsVariant2(state, getters) {
    const {
      appPropsMap: {
        abTestNames,
        launchToggles
      }
    } = getters;
    return launchToggles.enableExpertiseChatV2 || getters.getEligibleTests.some((test) => `${test.aName}:${test.exp}` === abTestNames.scsVariant2);
  },
  isGladlyTestCategory(state) {
    const simpleBreadcrumbs = state.product.breadcrumbs.map((bc) => bc.item.canonical);
    const categories = ["camping-and-hiking", "cycling", "running", "womens-running-shorts", "womens-running-pants-and-tights", "womens-running-shirts", "mens-running-shorts", "mens-running-vests", "mens-running-pants-and-tights", "womens-jackets", "mens-jackets", "mens-running-shirts", "womens-road-running-shoes", "mens-road-running-shoes", "womens-trail-running-shoes", "mens-trail-running-shoes", "downhill-skis", "cross-country-skis", "bikes", "day-bags-and-packs", "womens-hiking-boots", "mens-hiking-boots", "womens-hiking-shoes", "mens-hiking-shoes", "womens-base-layer-tops", "mens-base-layer-tops", "womens-base-layer-bottoms", "mens-base-layer-bottoms"];
    return simpleBreadcrumbs.some((bc) => categories.includes(bc));
  },
  isInGladlyTest(state, getters) {
    return getters.getEligibleTests.some((test) => test.name === InternalTestNames.GLADLY_TEST);
  },
  // MEM-3248
  // AB test active with treatment value
  // full price item is selected
  // It is a mixed price page
  // we are in MABC window
  shouldShowBillboardsMixedPrice(state, getters) {
    const {
      getEligibleTests
    } = getters;
    const showBillboardsMixedPriceTest = getEligibleTests.find((test) => test.name === "PDP_showBillboardsMixedPrice");
    const isTreatmentVariant = (showBillboardsMixedPriceTest == null ? void 0 : showBillboardsMixedPriceTest.exp) === "treatment";
    return isTreatmentVariant && !getters.priceInfo.showPercentOffSavings && !state.product.displayOptions.showDividendMessage && getters.appPropsMap.mabcEarnPeriodToggle;
  },
  /* end MEM-3248 test */
  /**
   * PDX-5643 Hide QA Test
   * getters.showStickyPageNav
   * @param {boolean} appPropsMap.launchToggles.showQASection: feature toggles
   * @returns {boolean}
   */
  enableQASection(state, getters) {
    var _a;
    const hideQATest = (_a = getters == null ? void 0 : getters.getEligibleTests) == null ? void 0 : _a.find((test) => test.name === InternalTestNames.HIDE_QA_SECTION && test.exp.toLowerCase().trim() !== "control");
    if (hideQATest) return false;
    return getters.appPropsMap.launchToggles.showQASection;
  },
  isInQATest(state, getters) {
    var _a;
    return (_a = getters == null ? void 0 : getters.getEligibleTests) == null ? void 0 : _a.some((test) => test.name === InternalTestNames.HIDE_QA_SECTION);
  },
  /* end PDX-5643  Hide QA Test */
  /**
   * PDX-5650 Coop Brand Test
   * getters.showCoopBrandTest
   * @param {boolean} appPropsMap.launchToggles.enableCoopBrandAsset: feature toggles
   * @returns {boolean}
   */
  showCoopBrandAsset(state, getters) {
    var _a;
    const {
      name
    } = state.product.brand;
    const selectedBrands = ["rei co-op", "co-op cycles"];
    const areTogglesEnabled = getters.appPropsMap.launchToggles.enableCoopBrandAssetVideo || getters.appPropsMap.launchToggles.enableCoopBrandAssetStatic || getters.appPropsMap.launchToggles.enableCoopBrandAssetGif;
    const isExperienceActive = ((_a = getters == null ? void 0 : getters.getEligibleTests) == null ? void 0 : _a.some((test) => test.name === InternalTestNames.COOP_BRAND_ASSET)) || areTogglesEnabled;
    return selectedBrands.some((brand) => {
      var _a2;
      return brand === ((_a2 = name == null ? void 0 : name.trim) == null ? void 0 : _a2.call(name).toLowerCase());
    }) && isExperienceActive;
  },
  getCoopBrandAssetType(state, getters) {
    var _a;
    const activeExp = (_a = getters == null ? void 0 : getters.getEligibleTests) == null ? void 0 : _a.find((test) => test.name === InternalTestNames.COOP_BRAND_ASSET);
    let exp = "";
    if (activeExp) exp = activeExp.exp;
    if (exp === "variant1" || getters.appPropsMap.launchToggles.enableCoopBrandAssetVideo) return 1;
    if (exp === "variant2" || getters.appPropsMap.launchToggles.enableCoopBrandAssetStatic) return 2;
    if (exp === "variant3" || getters.appPropsMap.launchToggles.enableCoopBrandAssetGif) return 3;
    return 0;
  },
  /* end PDX-5650 Coop Brand test */
  hideStaffPickBadge(state, getters) {
    const {
      staffPicksBadgeVariant
    } = getters.appPropsMap.abTestNames;
    return getters.getEligibleTests.some((test) => test.exp === staffPicksBadgeVariant);
  },
  /* PDX-5732 Klarna Test Start */
  showKlarnaAboveATC(state, getters) {
    const klarnaTest = getters.getEligibleTests.find((t) => t.name === InternalTestNames.KLARNA_V2);
    return (klarnaTest == null ? void 0 : klarnaTest.exp) === "above" || getters.appPropsMap.launchToggles.enableKlarnaAbove;
  },
  showKlarnaBelowATC(state, getters) {
    const klarnaTest = getters.getEligibleTests.find((t) => t.name === InternalTestNames.KLARNA_V2);
    return (klarnaTest == null ? void 0 : klarnaTest.exp) === "below" || getters.appPropsMap.launchToggles.enableKlarnaBelow;
  },
  /* PDX-5732 Klarna Test End */
  /* MEM-3289 "Membership Rewards Placements" test */
  hideRewardsPlacements(state, getters) {
    const {
      getEligibleTests
    } = getters;
    const rewardsPlacementsTest = getEligibleTests.find((t) => t.name === InternalTestNames.REWARDS_PLACEMENTS);
    const testVariant = getters.appPropsMap.abTestNames.rewardsPlacementsVariant;
    const isTreatmentVariant = (rewardsPlacementsTest == null ? void 0 : rewardsPlacementsTest.exp) === testVariant;
    return isTreatmentVariant && state.product.displayOptions.showDividendMessage && !getters.priceInfo.showPercentOffSavings;
  },
  // PDX-5828 Parity Reviews
  showReviewsVariant(state, getters) {
    var _a, _b;
    const parityReviews = getters.getEligibleTests.find((t) => t.name === InternalTestNames.PARITY_REVIEWS);
    return ((parityReviews == null ? void 0 : parityReviews.exp) === "variant" || ((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.launchToggles) == null ? void 0 : _b.showNativeReviews)) ?? false;
  }
  // End PDX 5828 Parity Reviews
};
export {
  testGetters as default
};
//# sourceMappingURL=testGetters.mjs.map
